'use client'

import { UserType } from '@/entities/user'
import { Link } from '@/shared/i18n'
import { useFormatDate, usePagination } from '@/shared/lib'
import { Layout, Pagination } from '@/shared/ui'

import { useNotices } from '../../api/get-notices'

type Props = {
  userType: UserType
}

export const NoticeList = ({ userType }: Props) => {
  const { page, handlePageChange } = usePagination()
  const { formatDate } = useFormatDate()

  const { notices, lastPage } = useNotices({ userType, page })

  return (
    <Layout className="mt-0 mb-15 flex flex-col">
      <ul className="mb-10 flex grow flex-col">
        {notices.map(notice => (
          <li
            key={notice.id}
            className="group border-b border-gray-50 last:border-none"
          >
            <Link
              href={`/${userType}/notice/${notice.id}`}
              className="block py-5 group-first:pt-0 group-last:pb-0"
            >
              <div className="flex h-[42px] items-center gap-6">
                <h2 className="typo-body1 line-clamp-1 grow font-semibold text-gray-900">
                  {notice.title}
                </h2>
                <p className="typo-label1 font-normal text-gray-500">
                  {formatDate({ date: notice.writeDate })}
                </p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
      <Pagination
        current={page}
        total={lastPage}
        onPageChange={handlePageChange}
      />
    </Layout>
  )
}
